import { sprinkles } from '@design-system/sprinkles.css';
import { ListItem } from './ListItem';
import { listWrapper, listWrapperEdit } from './VideoUploadStateModal.css';
import { Typography } from '@design-system/components/typography/typography';
import { clsx } from 'clsx';
import { ListEditItem } from './ListEditItem';
import { UploadVideoVM } from '../../view-models/uploadVideo.viewModel';
import { FailedList } from './FailedList';
import { InvalidFilesList } from './InvalidFiles';

export const UploadList = ({
  files,
  failedFiles,
  invalidFiles,
  dispatch,
  showItemEdit,
  listStatus,
  fileInEdit,
  uploadMap,
  show,
}: Pick<UploadVideoVM, 'dispatch'> & UploadVideoVM['list']) => {
  if (!show) return null;

  return (
    <>
      <div
        className={sprinkles({
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        })}
      >
        <Typography>{listStatus.primary}</Typography>
        {listStatus?.secondary ? (
          <Typography>{listStatus.secondary}</Typography>
        ) : null}
      </div>
      <InvalidFilesList
        invalidFiles={invalidFiles}
        dispatch={dispatch}
        uploadMap={uploadMap}
      />
      <FailedList
        failedFiles={failedFiles}
        dispatch={dispatch}
        uploadMap={uploadMap}
      />
      {files.length > 0 ? (
        <div className={clsx(listWrapper, showItemEdit && listWrapperEdit)}>
          {files.map((item, index) => (
            <div key={item.id}>
              {showItemEdit && fileInEdit === index ? (
                <ListEditItem item={item} dispatch={dispatch} index={index} />
              ) : (
                <ListItem
                  item={item}
                  dispatch={dispatch}
                  index={index}
                  uploadState={uploadMap[item.id]}
                />
              )}
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};
